import React from 'react'

import StoreLink from './store-link'
import Markdown from '../../parts/markdown'

const StorePurchaseStates = (props) => {
  if (!props.data || props.data === null) {
    return ''
  }
  const pageContext = props.pageContext
  const stores = props.data
  const strings = props.strings

  const linksReleased = stores.map((store, i) => (
    store.purchaseState === 'released' && (
      <StoreLink
        index={i}
        pageContext={pageContext}
        layout={props.layout}
        data={store}
        eventData={props.eventData}
        className={`${props.storeClassName ? props.storeClassName : ''}`}
        logoSize={props.logoSize ? props.logoSize : 'large'}
      />
    )
  ))
  const linksPrePurchase = stores.map((store, i) => (
    store.purchaseState === 'pre-purchase' && (
      <StoreLink
        index={i}
        pageContext={pageContext}
        layout={props.layout}
        data={store}
        eventData={props.eventData}
        className={`${props.storeClassName ? props.storeClassName : ''}`}
        logoSize={props.logoSize ? props.logoSize : 'large'}
      />
    )
  ))
  const linksWishlist = stores.map((store, i) => (
    store.purchaseState === 'wishlist' && (
      <StoreLink
        index={i}
        pageContext={pageContext}
        layout={props.layout}
        data={store}
        eventData={props.eventData}
        className={`${props.storeClassName ? props.storeClassName : ''}`}
        logoSize={props.logoSize ? props.logoSize : 'large'}
      />
    )
  ))

  return (
    <>
      {linksReleased && linksReleased.filter(Boolean).length >= 1 && (
        <div className={props.className ? props.className : ''}>
          <h3>{strings.cta && strings.cta.buyNow ? strings.cta.buyNow : 'Buy now'}</h3>
          <ul>
            {linksReleased}
          </ul>
        </div>
      )}
      {linksPrePurchase && linksPrePurchase.filter(Boolean).length >= 1 && (
        <div className={props.className ? props.className : ''}>
          <h3>{strings.cta && strings.cta.prePurchaseNow ? strings.cta.prePurchaseNow : 'Pre-purchase now'}</h3>
          <ul>
            {linksPrePurchase}
          </ul>
          {strings.labels && strings.labels.prePurchaseDisclaimer && props.product === 'mym-deluxe-game' && (
            <p>
              <Markdown children={strings.labels.prePurchaseDisclaimer} />
            </p>
          )}
        </div>
      )}
      {linksWishlist && linksWishlist.filter(Boolean).length >= 1 && (
        <div className={props.className ? props.className : ''}>
          <h3>{strings.cta && strings.cta.wishlistNow ? strings.cta.wishlistNow : 'Wishlist now'}</h3>
          <ul>
            {linksWishlist}
          </ul>
          {strings.labels && strings.labels.wishlistDisclaimer && (
            <p>
              <Markdown children={strings.labels.wishlistDisclaimer} />
            </p>
          )}
        </div>
      )}
    </>
  )
}

export default StorePurchaseStates